import IEntityApiService from 'services/entityApi/IEntityApiService';
import IGeoDistanceCalculationService, { GeoDistanceCalculationService } from './IGeoDistanceCalculationService';
import IHttpService from 'services/http/IHttpService';
import NavigateBackendUtils from 'utils/NavigateBackend';

export default class GeoDistanceCalculationServiceImpl implements IGeoDistanceCalculationService {
  constructor(private entityApiService: IEntityApiService, private path: string) {}

  public async getDistanceOutsideCityFromShop(shopId: string, pointLat: number, pointLon: number) {
    let path = this.path + '/distance';
    path = NavigateBackendUtils.addParamsToExistedUrl(path, { shopId, pointLon, pointLat });
    return this.entityApiService.getRawWithCredentialsParsed<{ distance: number }>(path).then((res) => res.distance);
  }
  public async getRouteAndDistanceOutsideCityFromShop(shopId: string, pointLat: number, pointLon: number) {
    let path = this.path + '/boundary';
    path = NavigateBackendUtils.addParamsToExistedUrl(path, { shopId, pointLon, pointLat });
    return this.entityApiService.getRawWithCredentialsParsed<GeoDistanceCalculationService.GeoRouteDistanceInformation>(path);
  }
}
